var blockquote = {
    content: 'paragraph+',
    group: 'block',
    defining: true,
    selectable: false,
    parseDOM: [{ tag: 'blockquote' }],
    toDOM: function () {
        return ['blockquote', 0];
    },
};

export { blockquote };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/blockquote.js